import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "60",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#D1E0FF\" d=\"M0 2.5C0 1.12 1.79 0 4 0h40c2.21 0 4 1.12 4 2.5v15c0 1.38-1.79 2.5-4 2.5H4c-2.21 0-4-1.12-4-2.5v-15Z\"></path><rect width=\"8\" height=\"6\" x=\"6\" y=\"7\" fill=\"#fff\" rx=\"3\"></rect><rect width=\"26\" height=\"6\" x=\"16\" y=\"7\" fill=\"#fff\" rx=\"3\"></rect><path fill=\"#D1E0FF\" d=\"M0 26.5C0 25.12 1.79 24 4 24h40c2.21 0 4 1.12 4 2.5v15c0 1.38-1.79 2.5-4 2.5H4c-2.21 0-4-1.12-4-2.5v-15Z\"></path><rect width=\"8\" height=\"6\" x=\"6\" y=\"31\" fill=\"#fff\" rx=\"3\"></rect><rect width=\"26\" height=\"6\" x=\"16\" y=\"31\" fill=\"#fff\" rx=\"3\"></rect><path fill=\"#2970FF\" d=\"M0 52a4 4 0 0 1 4-4h40a4 4 0 0 1 4 4v4a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4v-4Z\"></path><path stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.667 54H3.334m0 0 2 2m-2-2 2-2M39.666 54h4.667m0 0L42 51.667M44.333 54 42 56.334\"></path>", 8)
const _hoisted_10 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_10))
}
export default { render: render }